import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { DialogContext } from 'app/shared/ui/dialogs/dialog-context.model';
import { hideDialog, showDialog } from './dialog.actions';

export interface State {
    queue: DialogContext[];
}

export const initialState: State = {
    queue: [],
};

export const dialogReducer = createReducer(
    initialState,
    on(showDialog, (state, { context }) => ({
        ...state,
        queue: [...state.queue, context],
    })),
    on(hideDialog, state => ({
        ...state,
        queue: state.queue.slice(1),
    }))
);

const selector = createFeatureSelector<State>('dialog');

export const getDialog = createSelector(selector, (state: State) => state.queue[0] || null);
